import { Component, OnInit, OnDestroy } from '@angular/core';
import { CMSContentService } from '../../essentials/cms/content/cms-content.service';
import { Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { HeaderService } from './header.service';
import { environment } from 'apps/portal/src/environments/environment';
@Component({
  selector: 'fcp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public data = [];
  public actions = [];
  public environment = environment;

  private menuEvent = new Subject<any>();
  private menuEventSubscription: Subscription;
  private navbarContentSubscription: Subscription;

  constructor(
    private cmsContentService: CMSContentService,
    private headerService: HeaderService
  ) {}

  ngOnInit() {
    this.navbarContentSubscription = this.cmsContentService
      .return('navbar')
      .subscribe(response => {
        this.setItems(
          response.items.sort((a, b) => a.data.order.iv - b.data.order.iv)
        );
      });

    this.menuEventSubscription = this.menuEvent
      .pipe(
        map(e => {
          return document.getElementById('checkbox');
        })
      )
      .subscribe(el => {
        el['checked'] = false;
      });
  }

  public clicked(): void {
    this.menuEvent.next();
  }

  public emitCloseSearch() {
    this.headerService.emitCloseSearch();
  }

  ngOnDestroy() {
    this.menuEventSubscription.unsubscribe();
    this.navbarContentSubscription.unsubscribe();
  }

  setItems(items: any[]) {
    this.data = items.map(item => {
      return {
        title: item.data.Titulo.iv,
        content: item.data.Conteudo.iv,
        url: item.data.Nome.iv
      };
    });
  }
}
